import React, { FC } from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'

type ProgressSectionProps = {
    progress: number
    color: 'primary' | 'secondary'
    textColor?: 'primary' | 'secondary'
    width?: string
}

export const ProgressSection: FC<ProgressSectionProps> = ({
    progress,
    color,
    textColor,
    width
}) => {
    if (progress && progress >= 0) {
        return (
            <div className={`${width ?? 'w-9'}`}>
                <CircularProgressbar
                    styles={buildStyles({
                        pathColor: color === 'secondary' ? '#8C81F8' : '#49b848',
                        textColor: textColor === 'secondary' ? '#000' : '#fff',
                        textSize: '24px',
                        trailColor: 'rgba(255, 255, 255, 0.1)'
                    })}
                    value={progress}
                    minValue={0}
                    maxValue={100}
                    text={`${progress}%`}
                    strokeWidth={8}
                />
            </div>
        )
    }

    return null
}
